import React, { useState } from 'react';
import {
  View, Text, FlatList, Alert,
} from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { Appbar, Button, Checkbox } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import { GET_EQUIPMENTS } from '../../gql/equipment/query';
import { ASSIGN_EQUIPMENT_TO_BAG } from '../../gql/equipment/mutation';
import { styles } from './AssignEquipmentToBagScreen.style';
import { SCREEN_NAMES } from '../../utils/constant';

function AssignEquipmentToBagScreen({ route }) {
  const { bagId, qrCode, refetchBagDetails } = route.params;
  const navigation = useNavigation();
  const { data, loading, error } = useQuery(GET_EQUIPMENTS);
  const [assignEquipmentToBag] = useMutation(ASSIGN_EQUIPMENT_TO_BAG);

  const [selectedEquipments, setSelectedEquipments] = useState([]);

  const handleSelectEquipment = (equipmentId) => {
    if (selectedEquipments.includes(equipmentId)) {
      setSelectedEquipments(selectedEquipments.filter((id) => id !== equipmentId));
    } else {
      setSelectedEquipments([...selectedEquipments, equipmentId]);
    }
  };

  const handleAssign = async () => {
    try {
      await Promise.all(
        selectedEquipments.map((equipmentId) => assignEquipmentToBag({
          variables: {
            bagId,
            equipmentId,
          },
        })),
      );
      if (refetchBagDetails) {
        refetchBagDetails();
      }
      navigation.navigate(SCREEN_NAMES.BAG_DETAILS, { qrCode });
    } catch (e) {
      Alert.alert('Error', e.message);
    }
  };

  if (loading) return <Text>Chargement des équipements...</Text>;
  if (error) {
    return (
      <Text>
        Error:
        {error.message}
      </Text>
    );
  }

  return (
    <View style={styles.container}>
      <Appbar.Header statusBarHeight={0}>
        <Appbar.BackAction onPress={() => navigation
          .navigate(SCREEN_NAMES.BAG_DETAILS, { qrCode })}
        />
        <Appbar.Content title="Assigner un équipement" />
      </Appbar.Header>
      <FlatList
        data={data.equipments}
        keyExtractor={(item) => item.id.toString()}
        renderItem={({ item }) => (
          <View style={styles.item}>
            <Text>{item.name}</Text>
            <Checkbox.Android
              status={selectedEquipments.includes(item.id) ? 'checked' : 'unchecked'}
              onPress={() => handleSelectEquipment(item.id)}
            />
          </View>
        )}
      />
      <Button
        mode="contained"
        onPress={handleAssign}
        disabled={selectedEquipments.length === 0}
      >
        Assigner
      </Button>
    </View>
  );
}

export default AssignEquipmentToBagScreen;
